import { BORDER_COLORS, SURFACE_COLORS, TEXT_COLORS } from '@constants/colors.ts';
import { STYLED_COMPONENTS_TEXT } from '@constants/text.ts';
import styled from 'styled-components';

export const CardProgressBarWrapper = styled.div`
    display: flex;
    width: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 8px;
`;

export const CardProgressBarGraphic = styled.div<{ $bgColor?: string }>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 100px;
    background: ${({ $bgColor }) => $bgColor || BORDER_COLORS.secondary};
`;

interface StyledCardProgressBarProps {
    $progressPercent: string;
    $bgColor?: string;
    $animated?: boolean;
}

export const CardProgressBarSpendTime = styled.div<StyledCardProgressBarProps>`
    height: 6px;
    width: ${({ $progressPercent }) => `${$progressPercent}%`};
    border-radius: 100px;
    background-color: ${({ $bgColor }) => $bgColor || SURFACE_COLORS.action};
    transition: ${({ $animated }) => ($animated ? 'width 0.6s ease-out' : 'none')};
`;

export const CardProgressText = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 8px;
    align-self: stretch;
`;
export const CardProgressTextPercent = styled(STYLED_COMPONENTS_TEXT['body/xs/xs'])`
    flex: 1 0 0;
    color: ${TEXT_COLORS.body};
`;
export const CardProgressMinLeft = styled(STYLED_COMPONENTS_TEXT['body/xs/xs'])`
    color: ${TEXT_COLORS.body};
`;
